// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox .custom-control-label[data-v-3f67e82f]::before {\n    border-radius: .50rem!important;cursor: pointer;\n}\n.no-image-gallery i.far[data-v-3f67e82f] {\n  font-size: 42px;\n  color: #959595;\n}\n.mdb-time-picker .clockpicker-span-hours[data-v-3f67e82f],\n.mdb-time-picker .clockpicker-span-minutes[data-v-3f67e82f] {\n    color: #4285f4 !important;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
